import MessagingContract from '../contracts/MessagingContract.js';
import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import {MESSAGING} from 'decentralized/transactions/contracts.js';
import BackendQuery from '../BackendQuery.js';
import {PublicMessageSent} from '../EthereumEvents.js';
import ipfs from '../Ipfs.js';
import accounts from 'accounts/Accounts.js';
import {convertAddress} from '../convertAddress.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {DIRECT} from './message-types.js';

const messagingContract = new MessagingContract();

class Messaging {
    constructor(web3) {
        this.web3 = web3;
        this.contract = messagingContract.getContract(web3);
        this.contractAddress = messagingContract.contractAddress;
    }

    sendMessage(toUser, referenceHash=null, messageType=DIRECT, messageContent) {
        return new Promise(async (resolve, reject) => {
            if (toUser === undefined) {
                toUser = await accounts.getAccount();
            }

            let message = {
                type: messageType,
                referenceHash: referenceHash,
                content: messageContent,
            };
            
            // use central ipfs so messages are actually saved correctly
            let messageSent = await ipfs.addJson(message, true);
            let contentHash = ipfsHashToBytes32(messageSent);
            if (referenceHash !== null) {
                referenceHash = ipfsHashToBytes32(referenceHash);
            } else {
                referenceHash = this.web3.utils.padLeft('0x0', 64);
            }
            new EthereumTransaction(
                MESSAGING,
                'sendPublicMessage',
                [toUser, referenceHash, contentHash])
                .execute()
                .then(() => {
                    resolve(messageSent);
                });
        }); 
    }

    async getMessages(referenceHash=null, toUser) {
        let query = await this.getQuery(referenceHash, toUser);
        let results = await query.executeQuery();
        return results;
    }

    async watchForNewMessages(referenceHash=null, toUser, callback) {
        let query = await this.getQuery(referenceHash, toUser);
        query.watchQuery(callback);
    }

    async getQuery(referenceHash=null, toUser) {
        /*
        if (toUser === undefined) {
            const account = await accounts.getAccount();
            if (account) {
                toUser = account.toLowerCase();
            }
        }
        */

        let query = new BackendQuery(this.contractAddress)
            .from(PublicMessageSent)
            .select('fromUser')
            .select('referenceHash')
            .select('messageHash')
            .where('referenceHash', referenceHash);
        if (toUser) {
            query.where('toUser', toUser);
        }
        return query;
    }
}

export default Messaging;
